import { toast } from "react-toastify";
import firebase from "../../config/firebase";

export const addResolutions =
  (formData, oncomplete = () => {}) =>
  async (dispatch) => {
    try {
      const docRef = await firebase
        .firestore()
        .collection("resolutions")
        .add(formData);
      const notificationData = {
        createdAt: firebase.firestore.FieldValue.serverTimestamp(),
        type: "resolution",
        notifyID: docRef.id,
        status: false
      };
      await firebase
        .firestore()
        .collection("admin_notifiaction")
        .add(notificationData);
      oncomplete();
      dispatch(getResolutions(formData?.userId, "", () => {}));
      toast.success("Resolution Added Successfully");
    } catch (error) {
      console.error("Error adding resolution:", error);
    }
  };

export const getResolutions =
  (ID, lastDocument, onSuccess = () => {}) =>
  async (dispatch) => {
    try {
      dispatch(IsLoader(true));

      let query = firebase
        .firestore()
        .collection("resolutions")
        .where("userId", "==", ID)
        .orderBy("createdAt");

      if (lastDocument) {
        query = query.startAfter(lastDocument);
      }

      const unsubscribe = query.limit(5).onSnapshot(
        (snapshot) => {
          let temp_data = [];
          snapshot.forEach((doc) => {
            temp_data.push({
              id: doc.id,
              ...doc.data()
            });
          });

          dispatch({
            type: lastDocument ? "GET_RESOLUTION_MORE" : "GET_RESOLUTION",
            payload: {
              data: temp_data,
              lastDocument: snapshot.docs[temp_data.length - 1] || null,
              hasMoreDocument: temp_data.length >= 5
            }
          });

          dispatch(IsLoader(false));
          onSuccess(temp_data);
          unsubscribe();
        },
        (error) => {
          console.error("Error fetching resolutions:", error);
          dispatch(IsLoader(false));
          onSuccess([]);
        }
      );
    } catch (error) {
      console.error("Error in getResolutions:", error);
      dispatch(IsLoader(false));
    }
  };

export const resolutionChat = (ID) => async (dispatch) => {
  try {
    dispatch(IsLoader(true));
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      toast.error("Not authenticated");
      dispatch(IsLoader(false));
      return;
    }

    const unsubscribe = firebase.firestore().collection("resolutions").doc(ID);
    let athleteData = await unsubscribe.get();
    if (athleteData.exists && athleteData.data().userId !== currentUser.uid) {
      toast.error("Unauthorized access to resolution");
      dispatch(IsLoader(false));
      return;
    }

    const unsubscribeSnapshot = unsubscribe
      .collection("messages")
      .orderBy("createdAt", "asc")
      .onSnapshot(async (querySnapshot) => {
        const chats = [];
        querySnapshot.forEach((doc) => {
          chats.push(doc.data());
        });

        const athleteId = athleteData.id;

        dispatch({
          type: "GET_RESOLUTION_CHAT",
          payload: {
            chats,
            athleteData: { id: athleteId, data: athleteData.data() }
          }
        });
        dispatch(IsLoader(false));
      });

    return () => {
      unsubscribeSnapshot();
      unsubscribe();
    };
  } catch (error) {
    console.error(error);
    dispatch(IsLoader(false));
  }
};

export const addChat = (resolutionId, data, senderId) => async (dispatch) => {
  try {
    const currentUser = firebase.auth().currentUser;
    if (!currentUser) {
      toast.error("Not authenticated");
      return;
    }

    const resolutionsCollectionRef = firebase
      .firestore()
      .collection("resolutions");

    const resolutionDocRef = resolutionsCollectionRef.doc(resolutionId);
    const resolutionSnap = await resolutionDocRef.get();
    if (resolutionSnap.exists && resolutionSnap.data().userId !== currentUser.uid) {
      toast.error("Unauthorized message addition");
      return;
    }

    const messagesCollectionRef = resolutionDocRef.collection("messages");

    const timestampedData = {
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      message: data,
      senderId: senderId
    };

    const newMessageDocRef = await messagesCollectionRef.add(timestampedData);

    dispatch({ type: "ADD_CHAT_SUCCESS", payload: newMessageDocRef.id });
  } catch (error) {
    console.error(error);
    dispatch({ type: "ADD_CHAT_FAILURE", payload: error.message });
  }
};

export const IsLoader = (val) => async (dispatch) => {
  dispatch({
    type: "SET_IS_LOADINGS",
    payload: val
  });
};
